<mibi-single-center-card-layout cardTitle="Login">
    <mibi-login-container mibi-card-content></mibi-login-container>
    <div mibiCardActions class="mibi-login-actions">
        <a
            class="mibi-login-actions__button"
            mat-button
            [routerLink]="[userLinks.register]"
            color="primary"
            >Registrierung</a
        >
        <a
            class="mibi-login-actions__button"
            mat-button
            [routerLink]="[userLinks.recovery]"
            color="primary"
            >Passwort vergessen?</a
        >
    </div>
</mibi-single-center-card-layout>
